/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertAllowedOriginForm,
  UpsertAllowedOriginForm$Outbound,
  UpsertAllowedOriginForm$outboundSchema,
} from "../components/upsertallowedoriginform.js";

export type UpsertAllowedOriginSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpsertAllowedOriginSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpsertAllowedOriginSecurity = {
  option1?: UpsertAllowedOriginSecurityOption1 | undefined;
  option2?: UpsertAllowedOriginSecurityOption2 | undefined;
};

export type UpsertAllowedOriginRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  upsertAllowedOriginForm: UpsertAllowedOriginForm;
};

/** @internal */
export type UpsertAllowedOriginSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpsertAllowedOriginSecurityOption1$outboundSchema: z.ZodMiniType<
  UpsertAllowedOriginSecurityOption1$Outbound,
  UpsertAllowedOriginSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function upsertAllowedOriginSecurityOption1ToJSON(
  upsertAllowedOriginSecurityOption1: UpsertAllowedOriginSecurityOption1,
): string {
  return JSON.stringify(
    UpsertAllowedOriginSecurityOption1$outboundSchema.parse(
      upsertAllowedOriginSecurityOption1,
    ),
  );
}

/** @internal */
export type UpsertAllowedOriginSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpsertAllowedOriginSecurityOption2$outboundSchema: z.ZodMiniType<
  UpsertAllowedOriginSecurityOption2$Outbound,
  UpsertAllowedOriginSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function upsertAllowedOriginSecurityOption2ToJSON(
  upsertAllowedOriginSecurityOption2: UpsertAllowedOriginSecurityOption2,
): string {
  return JSON.stringify(
    UpsertAllowedOriginSecurityOption2$outboundSchema.parse(
      upsertAllowedOriginSecurityOption2,
    ),
  );
}

/** @internal */
export type UpsertAllowedOriginSecurity$Outbound = {
  Option1?: UpsertAllowedOriginSecurityOption1$Outbound | undefined;
  Option2?: UpsertAllowedOriginSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpsertAllowedOriginSecurity$outboundSchema: z.ZodMiniType<
  UpsertAllowedOriginSecurity$Outbound,
  UpsertAllowedOriginSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpsertAllowedOriginSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpsertAllowedOriginSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function upsertAllowedOriginSecurityToJSON(
  upsertAllowedOriginSecurity: UpsertAllowedOriginSecurity,
): string {
  return JSON.stringify(
    UpsertAllowedOriginSecurity$outboundSchema.parse(
      upsertAllowedOriginSecurity,
    ),
  );
}

/** @internal */
export type UpsertAllowedOriginRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpsertAllowedOriginForm: UpsertAllowedOriginForm$Outbound;
};

/** @internal */
export const UpsertAllowedOriginRequest$outboundSchema: z.ZodMiniType<
  UpsertAllowedOriginRequest$Outbound,
  UpsertAllowedOriginRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    upsertAllowedOriginForm: UpsertAllowedOriginForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      upsertAllowedOriginForm: "UpsertAllowedOriginForm",
    });
  }),
);

export function upsertAllowedOriginRequestToJSON(
  upsertAllowedOriginRequest: UpsertAllowedOriginRequest,
): string {
  return JSON.stringify(
    UpsertAllowedOriginRequest$outboundSchema.parse(upsertAllowedOriginRequest),
  );
}
